import React, {useMemo, useState} from 'react'
import {useDisplayNumber} from '../../../utils/number'
import ContainerLayout from '../../../components/layout/ContainerLayout'
import TableHeader from '../../../components/table/TableHeader'
import Text from '../../../components/text/Text'
import TableItem from '../../../components/table/TableItem'
import MoreButton from '../../../components/button/MoreButton'
import {IAssets} from '../../../apis/types/portfolio'
import Span from '../../../components/text/Span'
import {IAsset} from '../../../apis/user/getKeyProfile'

interface IProps {
    className?: string
    data?: IAsset[]
    subTitle?: string
    total?: number
}

const AssetContainer: React.FC<IProps> = ({className, data, subTitle, total}) => {
    const {floorBalance} = useDisplayNumber()
    const [showAll, setShowAll] = useState(false)

    const assetList = useMemo(() => {
        if (showAll) {
            return data
        } else {
            return data?.slice(0, 10)
        }
    }, [showAll, data])

    const totalInBase = useMemo(() => {
        if (!!total) {
            return total
        }
        if (data === undefined) {
            return 0
        }
        return data.reduce<number>((prev, curr) => {
            return (prev += curr.amount * curr.price_in_base)
        }, 0)
    }, [total])

    return (
        <ContainerLayout
            title={`${subTitle ? subTitle : ''} Assets`}
            className={`shadow-none sm:space-y-[20px] sm:text-center ${className}`}>
            <div
                className={
                    'text-right pb-[5px] flex justify-between px-[5px] sm:block sm:text-left sm:px-0 sm:border-b sm:border-line02 sm:pb-[10px]'
                }>
                <Text className={'text-ti3 text-font02'}>Total : {floorBalance(totalInBase, 100)}</Text>
            </div>
            <TableHeader className={'grid-cols-4 sm:hidden'}>
                <Text>Symbol</Text>
                <Text>Price</Text>
                <Text>Amount</Text>
                <Text>Total</Text>
            </TableHeader>

            {assetList?.map((item, idx) => (
                <TableItem key={idx} className={'grid-cols-4 sm:grid-cols-1 sm:text-left'}>
                    <Text className={'sm:text-ti2'}>
                        <Span className={'hidden sm:inline'}>Token : </Span>
                        {item?.symbol}
                    </Text>
                    <Text>
                        <Span className={'hidden sm:inline'}>Price : </Span>
                        {floorBalance(item?.price_in_base)}
                    </Text>
                    <Text>
                        <Span className={'hidden sm:inline'}>Amount : </Span>
                        {item?.amount.toFixed(3)}
                    </Text>
                    <Text className={'text-ti2 sm:text-right sm:pt-[20px]'}>
                        <Span className={'hidden sm:inline '}>Total : </Span>
                        {floorBalance(Math.round(item?.amount * item?.price_in_base))}
                    </Text>
                </TableItem>
            ))}

            {!assetList?.length && (
                <TableItem className={'text-center'}>
                    <div>
                        <Text>No Items</Text>
                    </div>
                </TableItem>
            )}

            {!showAll && data?.length > 10 && (
                <div className={'text-center'}>
                    <MoreButton onClick={() => setShowAll(true)} />
                </div>
            )}
        </ContainerLayout>
    )
}

export default AssetContainer
